// extracted by mini-css-extract-plugin
export var category = "_ki-9";
export var categoryHeader = "_ki-e";
export var container = "_ki-0";
export var group = "_ki-a";
export var groupItems = "_ki-f";
export var groupSeparator = "_ki-j";
export var loading = "_ki-1";
export var noResults = "_ki-3";
export var placeholder = "_ki-2";
export var resultContent = "_ki-5";
export var resultIcon = "_ki-c";
export var resultItem = "_ki-g";
export var resultMeta = "_ki-8";
export var resultSubtitle = "_ki-7";
export var resultSuffix = "_ki-i";
export var resultTitle = "_ki-6";
export var resultsList = "_ki-4";
export var searchGroup = "_ki-d";
export var selected = "_ki-h";
export var subgroup = "_ki-b";